var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcEventos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2031 4.38452H16.9608C17.1958 4.79987 17.1973 5.35213 16.9654 5.76902H19.2031L19.2047 5.77056L19.2031 19.614L5.38224 19.6125L5.38378 5.76902H7.84878C7.61687 5.35213 7.6184 4.79987 7.85492 4.38452H5.38378C4.61894 4.38452 4 5.00447 4 5.77056V19.614C4 20.3785 4.61894 21 5.38378 21H19.2047C19.968 21 20.5884 20.3801 20.5884 19.614V5.77056C20.5869 5.00447 19.968 4.38452 19.2031 4.38452Z",
    fill: "#465471",
    stroke: "#465471",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.98801 5.76902H14.8274C14.5955 5.35213 14.597 4.79987 14.8335 4.38452H9.9834C10.2184 4.79987 10.2199 5.35213 9.98801 5.76902Z",
    fill: "#465471",
    stroke: "#465471",
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5869 8.53796H4V9.92246H20.5869V8.53796Z",
    fill: "#465471",
    stroke: "#465471",
    strokeWidth: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.83801 11.307H7.45577C7.07335 11.307 6.76465 11.6162 6.76465 11.9993C6.76465 12.3823 7.07335 12.6915 7.45577 12.6915H8.83801C9.22043 12.6915 9.52913 12.3823 9.52913 11.9993C9.52913 11.6162 9.22043 11.307 8.83801 11.307Z",
    fill: "#465471",
    stroke: "#465471",
    strokeWidth: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9845 11.307H11.6023C11.2198 11.307 10.9111 11.6162 10.9111 11.9993C10.9111 12.3823 11.2198 12.6915 11.6023 12.6915H12.9845C13.3669 12.6915 13.6756 12.3823 13.6756 11.9993C13.6756 11.6162 13.3669 11.307 12.9845 11.307Z",
    fill: "#465471",
    stroke: "#465471",
    strokeWidth: 0.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.131 11.307H15.7487C15.3663 11.307 15.0576 11.6162 15.0576 11.9993C15.0576 12.3823 15.3663 12.6915 15.7487 12.6915H17.131C17.5134 12.6915 17.8221 12.3823 17.8221 11.9993C17.8221 11.6162 17.5134 11.307 17.131 11.307Z",
    fill: "#465471",
    stroke: "#465471",
    strokeWidth: 0.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.83801 14.0759H7.45577C7.07335 14.0759 6.76465 14.3851 6.76465 14.7682C6.76465 15.1512 7.07335 15.4604 7.45577 15.4604H8.83801C9.22043 15.4604 9.52913 15.1512 9.52913 14.7682C9.52913 14.3851 9.22043 14.0759 8.83801 14.0759Z",
    fill: "#465471",
    stroke: "#465471",
    strokeWidth: 0.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9845 14.0759H11.6023C11.2198 14.0759 10.9111 14.3851 10.9111 14.7682C10.9111 15.1512 11.2198 15.4604 11.6023 15.4604H12.9845C13.3669 15.4604 13.6756 15.1512 13.6756 14.7682C13.6756 14.3851 13.3669 14.0759 12.9845 14.0759Z",
    fill: "#465471",
    stroke: "#465471",
    strokeWidth: 0.5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M17.131 14.0759H15.7487C15.3663 14.0759 15.0576 14.3851 15.0576 14.7682C15.0576 15.1512 15.3663 15.4604 15.7487 15.4604H17.131C17.5134 15.4604 17.8221 15.1512 17.8221 14.7682C17.8221 14.3851 17.5134 14.0759 17.131 14.0759Z",
    fill: "#465471",
    stroke: "#465471",
    strokeWidth: 0.5
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M8.83801 16.845H7.45577C7.07335 16.845 6.76465 17.1542 6.76465 17.5372C6.76465 17.9203 7.07335 18.2295 7.45577 18.2295H8.83801C9.22043 18.2295 9.52913 17.9203 9.52913 17.5372C9.52913 17.1542 9.22043 16.845 8.83801 16.845Z",
    fill: "#465471",
    stroke: "#465471",
    strokeWidth: 0.5
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9845 16.845H11.6023C11.2198 16.845 10.9111 17.1542 10.9111 17.5372C10.9111 17.9203 11.2198 18.2295 11.6023 18.2295H12.9845C13.3669 18.2295 13.6756 17.9203 13.6756 17.5372C13.6756 17.1542 13.3669 16.845 12.9845 16.845Z",
    fill: "#465471",
    stroke: "#465471",
    strokeWidth: 0.5
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4403 4.3845V5.76899H15.058V4.3845H16.4403ZM16.4403 3H15.058C14.2947 3 13.6758 3.61995 13.6758 4.3845V5.76899C13.6758 6.53354 14.2947 7.15349 15.058 7.15349H16.4403C17.2036 7.15349 17.8225 6.53354 17.8225 5.76899V4.3845C17.8225 3.61995 17.2036 3 16.4403 3Z",
    fill: "#465471",
    stroke: "#465471",
    strokeWidth: 0.5
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M9.52913 4.3845V5.76899H8.14689V4.3845H9.52913ZM9.52913 3H8.14689C7.38359 3 6.76465 3.61995 6.76465 4.3845V5.76899C6.76465 6.53354 7.38359 7.15349 8.14689 7.15349H9.52913C10.2924 7.15349 10.9114 6.53354 10.9114 5.76899V4.3845C10.9114 3.61995 10.2924 3 9.52913 3Z",
    fill: "#465471",
    stroke: "#465471",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEventos);
export default __webpack_public_path__ + "static/media/ic_eventos.583a8103c1714427158e65d06972d38f.svg";
export { ForwardRef as ReactComponent };